import { Stack } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
export function InstructorInfo({ instructor }) {
    return React.createElement(InstructorInfoBox, null,
        React.createElement(Avatar, { variant: "square", src: instructor.photo }),
        React.createElement(Typography, { variant: "overline2" }, instructor.name));
}
const InstructorInfoBox = styled(Stack)(({ theme }) => ({
    flexGrow: 0,
    flexShrink: 0,
    flexDirection: 'row',
    justifyContent: 'stretch',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    '& .MuiAvatar-root': {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    '.MuiTypography-overline': {
        color: theme.palette.grey['A400']
    }
}));
//# sourceMappingURL=InstructorInfo.js.map